import { render } from "./AccountGroups.vue?vue&type=template&id=1cb7e4da&scoped=true"
import script from "./AccountGroups.vue?vue&type=script&lang=js"
export * from "./AccountGroups.vue?vue&type=script&lang=js"

import "./AccountGroups.vue?vue&type=style&index=0&id=1cb7e4da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb7e4da"]])

export default __exports__